import { Container } from "@mui/material";
import Loading from "./Loading";

const FullPageLoading = () => {
  console.log("FullPageLoading");
  return (
    <Container maxWidth="xl" sx={{ display: "flex", justifyContent: "center", height: "100%" }}>
      <Loading />
    </Container>
  );
};

export default FullPageLoading;
